enum NavigationFooterAlignment {
	LEFT = 'LEFT',
	RIGHT = 'RIGHT',
	SPACE_BETWEEN = 'SPACE BETWEEN',
}

export default NavigationFooterAlignment;